import { Col, Form, Select } from "antd";
import { IMPORT_B2B_LC_LIST } from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import { useCallback, useEffect, useState } from "react";

const B2BLcOpeningCostFilterFields = ({ initialTableData }) => {
  const { Option } = Select;
  const [b2bLcs, setB2bLcs] = useState([]);
  const [loading, setLoading] = useState(false);

  const getB2BLCs = async (filter) => {
    setLoading(true);
    const body = {
      page: 1,
      per_page: 50,
      ...(filter?.b2b_lc_number && { b2b_lc_number: filter.b2b_lc_number }),
    };
    const response = await getData(IMPORT_B2B_LC_LIST, null, body);
    if (response?.status === 200) {
      setB2bLcs(response?.data?.data?.data || []);
    }
    setLoading(false);
  };

  // on search B2B LCs
  const onB2BLcSearch = useCallback(async (value) => {
    if (value && value.length >= 2) {
      await getB2BLCs({ b2b_lc_number: value });
    } else if (!value) {
      await getB2BLCs();
    }
  }, []);

  useEffect(() => {
    getB2BLCs();
  }, []);

  return (
    <>
      <Col span={4}>
        <Form.Item label="B2B LC Number" name="b2b_lc_number">
          <Select
            size="small"
            placeholder="Select B2B LC Number"
            loading={loading}
            showSearch
            optionFilterProp="children"
            onSearch={onB2BLcSearch}
            allowClear
          >
            {b2bLcs.map((lc) => (
              <Option key={lc.b2b_lc_id} value={lc.id}>
                {lc.b2b_lc_number}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default B2BLcOpeningCostFilterFields;
